var map = {
	"./add.svg": "./src/assets/icons/add.svg",
	"./arrowDown.svg": "./src/assets/icons/arrowDown.svg",
	"./arrowUp.svg": "./src/assets/icons/arrowUp.svg",
	"./br.svg": "./src/assets/icons/br.svg",
	"./camera.svg": "./src/assets/icons/camera.svg",
	"./copy.svg": "./src/assets/icons/copy.svg",
	"./delete.svg": "./src/assets/icons/delete.svg",
	"./done.svg": "./src/assets/icons/done.svg",
	"./en.svg": "./src/assets/icons/en.svg",
	"./es.svg": "./src/assets/icons/es.svg",
	"./faceFrame.svg": "./src/assets/icons/faceFrame.svg",
	"./face_overlay.svg": "./src/assets/icons/face_overlay.svg",
	"./restart.svg": "./src/assets/icons/restart.svg",
	"./settings-white.svg": "./src/assets/icons/settings-white.svg",
	"./success.svg": "./src/assets/icons/success.svg",
	"./take_photo.svg": "./src/assets/icons/take_photo.svg",
	"./translate.svg": "./src/assets/icons/translate.svg",
	"./us.svg": "./src/assets/icons/us.svg",
	"./values.svg": "./src/assets/icons/values.svg",
	"./white-camera.svg": "./src/assets/icons/white-camera.svg",
	"./white-check.svg": "./src/assets/icons/white-check.svg",
	"./white-restart.svg": "./src/assets/icons/white-restart.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*\\.svg$";